import { useTheme } from '@emotion/react'

export const navTransition = (theme) =>
  `${theme.timing.base} cubic-bezier(0.22, 1, 0.36, 1)`

const Navigation = (props) => {
  const theme = useTheme()

  return (
    <nav
      css={{
        justifySelf: 'end',
        display: 'grid',
        gridAutoColumns: 'auto',
        gridAutoFlow: 'column',
        alignItems: 'center',
        gap: theme.space.base,
      }}
      {...props}
    />
  )
}

export default Navigation
